import { http } from './http'

export interface ConfirmationState {
  success: boolean
  state?: 'pending' | 'accepted' | 'declined' | 'modified'
  status_text?: string
  created_at?: string
  updated_at?: string
}

export interface ConfirmationResponse {
  success: boolean
  message: string
  state?: string
}

export interface PriceChangeRequest {
  order_id: string
  price: number
  delivery_time: number
  comment?: string
}

/**
 * Получить текущее состояние подтверждения для заказа
 */
export const getConfirmationState = async (orderId: string): Promise<ConfirmationState> => {
  const response = await http.get(`/api/confirmations/${orderId}/state`)
  return response.data
}

/**
 * Сохранить состояние подтверждения
 */
export const saveConfirmationState = async (
  orderId: string, 
  state: string, 
  statusText?: string
): Promise<ConfirmationResponse> => {
  const response = await http.post('/api/confirmations/save-state', {
    order_id: orderId,
    state,
    status_text: statusText
  })
  return response.data
}

/**
 * Принять условия заказа
 */
export const acceptConfirmation = async (orderId: string): Promise<ConfirmationResponse> => {
  const response = await http.post('/api/confirmations/accept', {
    order_id: orderId,
    state: 'accepted'
  })
  return response.data
}

/**
 * Запросить изменение цены
 */
export const requestPriceChange = async (request: PriceChangeRequest): Promise<ConfirmationResponse> => {
  const response = await http.post('/api/confirmations/request-change', request)
  return response.data
}

/**
 * Очистить старые записи подтверждений
 */
export const cleanupOldConfirmations = async (orderId: string): Promise<{ success: boolean; message: string }> => {
  const response = await http.post(`/api/confirmations/cleanup-old?order_id=${orderId}`)
  return response.data
}
